export const routes = {
	externalStore: 'https://aertech.odoo.com/shop',
	HOME: '/',
	INDUSTRIAL: {
		HOME: '/industrial',
		DOCUMENTS: '/industrial/documents',
		ATEX: '/industrial/atex',
		CONTACT: '/industrial/contact',
		RENT: '/industrial/rent',
		CUSTOMIZATION: '/industrial/customization',
		PRODUCTS: '/industrial/products',
	},
	HOUSEHOLD: {
		HOME: '/household',
		DOCUMENTS: '/household/documents',
		FAQ: '/household/questions',
		CONTACT: '/household/contact',
		PRODUCTS: '/household/products',
	},
	ABOUT_US: '/about-us',
	ATEX: '/atex',
	PARTNERS: '/partners',
	REFERENCE: '/reference',
	PROJECTS: '/projects',
	PROJECT: '/projects/:slug',
	COMPARE: '/compare',
	CUSTOMIZATION: '/customization',
	ASBEST: '/asbest_kwartsstof',
	PRODUCTS: '/products',
	REPAIRS: '/repairs',
	PRODUCT_LIST: '/products/:slug',
	PRODUCT_DETAIL: '/products/:category/:slug',
	RENT: '/rent',
	RENT_DETAIL: '/rent/:slug',
	CMS: {
		DEFAULT: '/cms',
		LOGIN: '/login',
		PRODUCTS: '/products',
		PRODUCTS_OVERVIEW: '/products/:slug',
		CREATE_PRODUCT: '/products/create',
		ACCESSOIRES: '/accessoires',
		CREATE_ACCESSOIRES: '/accessoires/create',
		DOCUMENTS: '/documents',
		CREATE_DOCUMENTS: '/documents/create',
		PROJECTS: '/projects',
		CREATE_PROJECTS: '/projects/create',
		REFERENCE: '/references',
		CREATE_REFERENCE: '/references/create',
		FAQ: '/faq',
		CREATE_FAQ_SECTION: '/faq/section',
		CREATE_FAQ_Question: '/faq/section/create',
		USERS: '/users',
		CREATE_USERS: '/users/create',
		PO: '/po-file',
	},
};
export const PRODUCT_TYPE_UUIDS = {
	HOUSEHOLD: '1270b30c-5128-4425-a909-f1f1629b3bb7',
	INDUSTRIAL: '02886b55-6be7-4a06-b1f3-497fbfc4acf6',
	RENT: 'fee1bd47-a664-4964-9c6a-da3c4ae46fb1',
};

export const NLUuid = '489d6ac3-7b65-42c1-bdc6-67348bf7a112';



// WEBPACK FOOTER //
// ./src/constants.js